<label
  [class.govuk-visually-hidden]="!templateLabel() && isLabelHidden()"
  [for]="identifier"
  [id]="'l.' + identifier"
  [class]="currentLabelSize()"
>
  @if (!templateLabel()) {
    {{ currentLabel() }}
  } @else {
    <ng-content select="[govukLabel]" />
  }
</label>

@if (hint()) {
  <div [id]="identifier + '-hint'" class="govuk-hint">
    {{ hint() }}
  </div>
}

@if (shouldDisplayErrors) {
  <govuk-error-message [errors]="control.errors" [identifier]="identifier" />
}

@if (prefix() || suffix()) {
  <div class="govuk-input__wrapper">
    @if (prefix()) {
      <div aria-hidden="true" class="govuk-input__prefix">{{ prefix() }}</div>
    }
    <ng-container *ngTemplateOutlet="plainInput" />
    @if (suffix()) {
      <div aria-hidden="true" class="govuk-input__suffix">{{ suffix() }}</div>
    }
  </div>
} @else {
  @if (!disabled) {
    <input
      #input
      (blur)="handleBlur(getInputValue($event))"
      (focus)="onFocus()"
      (input)="onChange(getInputValue($event))"
      (keydown)="onKeyDown($event)"
      [attr.inputmode]="inputMode()"
      [autocomplete]="autoComplete()"
      [class.govuk-input--error]="shouldDisplayErrors"
      [disabled]="disabled"
      [id]="identifier"
      [name]="identifier"
      [ngClass]="widthClass()"
      [spellcheck]="spellCheck()"
      [type]="inputType() === 'number' ? 'text' : inputType()"
      class="govuk-input"
    />
  } @else {
    <p>
      {{ valueTransform() ? valueTransform()(control.value) : control.value }}
    </p>
  }
}

<ng-template #plainInput>
  @if (!disabled) {
    <input
      #input
      (blur)="handleBlur(getInputValue($event))"
      (focus)="onFocus()"
      (input)="onChange(getInputValue($event))"
      (keydown)="onKeyDown($event)"
      [attr.inputmode]="inputMode()"
      [autocomplete]="autoComplete()"
      [class.govuk-input--error]="shouldDisplayErrors"
      [disabled]="disabled"
      [id]="identifier"
      [name]="identifier"
      [ngClass]="widthClass()"
      [spellcheck]="spellCheck()"
      [type]="inputType() === 'number' ? 'text' : inputType()"
      class="govuk-input"
    />
  } @else {
    <p>
      {{ valueTransform() ? valueTransform()(control.value) : control.value }}
    </p>
  }
</ng-template>
